import { ChevronLeft, ChevronRight } from "react-feather";

import "./Styles/IndexPageGrid.scss";

const IndexFilterToggle = ({ filtersOpen, toggleFilters }) => {
  return (
    <span
      style={{
        position: "absolute",
        right: filtersOpen ? -4 : 7,
        top: 0,
        zIndex:1
      }}
      role="button"
      className="filters-toggle"
      onClick={toggleFilters}
    >
      {filtersOpen ? <ChevronRight /> : <ChevronLeft />}
    </span>
  );
};

export default IndexFilterToggle;
